import { APP_COLOR, FONT_FAMILY } from "../theme";

export const notFoundPageStyles = {
  notFoundPageContainer: {
    height: 150,
    fontFamily: FONT_FAMILY,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontWeight: "bold",
    flexDirection: "column",
    margin: 80,
  } as const,
  goToMainPageButton:{
    backgroundColor: APP_COLOR,
    color: "black",
    textTransform: "none",
    fontFamily: FONT_FAMILY,
    fontWeight: "bold",
    fontSize: 16,
  }as const,
};
